import { code } from "@spscommerce/utils";

export const SpsTextareaExamples = {
    basic: {
        label: "Basic",
        description: "info about basic text areas",
        examples: {
            basic: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="haiku">
                            Haiku
                            <sps-label-help>A haiku is a three-line poem of 5, 7, and 5 syllables respectively.</sps-label-help>
                            <sps-label-error *ngIf="form.get('haiku').hasError('numLines')">
                                You need {{form.get('haiku').errors['numLines'].requiredLines}} lines,
                                but you've only written {{form.get('haiku').errors['numLines'].actualLines}} lines!
                            </sps-label-error>
                        </sps-label>
                        <sps-textarea formControlName="haiku" placeholder="Write a haiku" rows="3"></sps-textarea>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        numLinesValidator(n: number): ValidatorFn {
                            return function(control: AbstractControl): ValidationErrors | null {
                                const lines = typeof control.value === "string" ? control.value.split("\\n").length : 0;
                                if (lines !== n) {
                                    return {
                                        numLines: {
                                            actualLines: lines,
                                            requiredLines: n
                                        }
                                    };
                                }
                                return null;
                            };
                        }
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                haiku: ["", this.numLinesValidator(3)]
                            })
                        }
                    }
                `
            }
        }
    },
    description: {
        label: "Description",
        description: "info about text areas with descriptions",
        examples: {
            description: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="textareaWithDescription"
                            description="This is a brief description of the field to provide additional context."
                        >
                            Label
                        </sps-label>
                        <sps-textarea formControlName="textareaWithDescription">
                        </sps-textarea>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                textareaWithDescription: []
                            })
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: "info about disabled text areas",
        examples: {
            disabled: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="notes">Notes</sps-label>
                        <sps-textarea formControlName="notes" rows="5"></sps-textarea>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                notes: [
                                    {
                                        value: "This is the value of the textarea but you can't edit it right now",
                                        disabled: true
                                    }
                                ]
                            })
                        }
                    }
                `
            }
        }
    }
};
